import { useQuery } from "react-query";
import { defineGroupFilterAndDriversOptions, getProducts } from "./services/ProductsService";
import { useProductStore } from "../viewModel/stores/productStore";
import { CACHE_TTL_MS } from "./ttl.cache";

export const useProducts = (options = {}) => {
  const { 
    shouldFetchProducts = false,
    shouldFetchFiltersAndDriversOptions = false,
    storeId = undefined 
  } = options;

  const setProductData = useProductStore((s) => s.setProductData);

  const groupFiltersAndDriversOptionsQuery = useQuery({
    queryKey: ["products"],
    queryFn: async () => {
      const groupFiltersAndDriversOptions = await defineGroupFilterAndDriversOptions();
      return { groupFiltersAndDriversOptions };
    },
    staleTime: CACHE_TTL_MS.TTL_6_HOURS,
    cacheTime: CACHE_TTL_MS.TTL_12_HOURS,
    
    refetchOnMount: false,
    enabled: shouldFetchFiltersAndDriversOptions,

    onSuccess: (data) => {
      setProductData(data);
    },
    ...options,
  });

  const productsQuery = useQuery({
    queryKey: ["products-by-store", storeId],
    queryFn: async () => {
      const data = await getProducts(storeId);
      return data;
    },
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: false,
    enabled: shouldFetchProducts,
  });

  return {
    groupFiltersAndDriversOptions: groupFiltersAndDriversOptionsQuery.data?.groupFiltersAndDriversOptions,
    isLoadingGroupFilters: groupFiltersAndDriversOptionsQuery.isLoading,
    products: productsQuery.data,
    isLoadingProducts: productsQuery.isLoading,
  };
};